var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    [
      _c(
        "router-link",
        {
          attrs: {
            to: { name: "bookings.show", params: { id: _vm.booking.id } },
          },
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.booking.name))]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-6" }, [
              _c("p", [
                _c("i", { staticClass: "fa fa-map-marker fa-fw" }),
                _vm._v(
                  " " + _vm._s(_vm._f("nullable")(_vm.bookingStateOrOnline))
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-6" }, [
              _vm.bookingAppearanceInPerson
                ? _c("p", [
                    _c("i", { staticClass: "fa fa-calendar fa-fw" }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "hidden-xs hidden-sm hidden-md" },
                      [
                        _vm._v(
                          _vm._s(_vm.bookingInPersonOpportunityName) +
                            " Event Date: "
                        ),
                      ]
                    ),
                    _vm._v(
                      _vm._s(
                        _vm._f("nullable")(
                          _vm._f("date")(
                            _vm.dateUserTz,
                            _vm.$user.date_format_preference
                          )
                        )
                      ) + "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.bookingAppearanceOnline
                ? _c("p", [
                    _c("i", { staticClass: "fa fa-globe fa-fw" }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "hidden-xs hidden-sm hidden-md" },
                      [
                        _vm._v(
                          _vm._s(_vm.bookingOnlineOpportunityName) + " Due By: "
                        ),
                      ]
                    ),
                    _vm._v(
                      _vm._s(
                        _vm._f("nullable")(
                          _vm._f("date")(
                            _vm.booking.complete_by_date,
                            _vm.$user.date_format_preference
                          )
                        )
                      ) + "\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12" }, [
              _c("p", { staticClass: "item-detail-talent-name" }, [
                _c("i", { staticClass: "fa fa-user fa-fw" }),
                _vm._v(" " + _vm._s(_vm.bookingBookedTalentNames)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-6" }, [
              _c("p", [_vm._v(_vm._s(_vm.bookingClientCompanyAndName))]),
            ]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "price" }, [
            _c("span", { staticClass: "amount" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.booking.budget_per_star_as_user_rate,
                    _vm.booking.currency
                  )
                )
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }